module.exports = __webpack_public_path__ + "static/media/test-project-by-dev-on-10-6-2020-2_1646626800787.80af0caa.srt";